export enum SignInSteps {
	login = 'login',
    emailConfirm = 'emailConfirm',
}
